import { externalReferrerHost } from '@bookkeeper/shared/first-touch-utm';

/**
 * The visitor's EXTERNAL referrer host (Google, a partner, an ad network), captured once when the
 * landing boots, before any in-app navigation replaces what `document.referrer` says (BOO-5163).
 *
 * Memory only: nothing is written to the device, so it needs no consent. A reload keeps the same
 * `document.referrer`, and the signup CTA hands the host to the app as `ref_host` (host only,
 * validated; our own domains are dropped).
 */
let referrerHost: string | undefined;

export function captureExternalReferrer(doc: Document = document): void {
  referrerHost = externalReferrerHost(doc.referrer);
}

export function getExternalReferrerHost(): string | undefined {
  return referrerHost;
}
